import React, { useEffect, useLayoutEffect, useState } from 'react';
import { ToastContainer, Slide, toast } from 'react-toastify';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import MainRoutes from './Routes/MainRoutes';
import jwt from 'jwt-decode';
import { useNavigate, useLocation } from 'react-router-dom';
import { logOut } from './reduxToolkit/authentication/authenticationSlice';
import { useDispatch } from 'react-redux';
import { GetUserByIdAtEntry, RoleCheck } from './reduxToolkit/authentication/AuthenticatonApi';
import cryptoJs from 'crypto-js';
import securekey from './config';
import FullPageLoader from './utils/FullPageLoader';
import { SnackbarProvider } from 'notistack';
import SecondPageLoader from './utils/SecondPageLoader';
import NavigationHandler from './components/NavigationHandler';
import { useTranslation } from 'react-i18next';
import { IsDevelopment } from './reduxToolkit/Commons/CommonsSlice';
import FingerPrintSpinner from './pages/Dashboard/Company/Employees/Modal/FingerPrintSpinner';
import {ROLE_NAME_DEFAULT_MODEL, USER_TYPE_MODEL, USER_TYPE_NAME_MODEL} from "./enums/userTypeEnum";
import NotificationsButton from './pages/Dashboard/Notifications/subcomponents/NotificationsButton';
import {NotificationsWebSocketApp} from "./pages/Dashboard/Notifications/Functionality/NotificationsWebSocketApp";
import {GetUserPreferencesByUserId} from "./reduxToolkit/UserPreferences/UserPreferencesApi";
import {syncI18nLanguageFromBackend} from "./Apis/functions";
import routes from './Routes/routes';

const App = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { t } = useTranslation();
    const Etoken = sessionStorage.getItem('bearerToken') || '';
    const bytes = cryptoJs.AES.decrypt(Etoken, securekey);
    const token = bytes.toString(cryptoJs.enc.Utf8);
    const userdata = sessionStorage.getItem('userdata');
    const bytess = cryptoJs.AES.decrypt(userdata || '', securekey);
    const userstring = bytess.toString(cryptoJs.enc.Utf8);
    const user = userstring ? JSON.parse(userstring)?.data?.data : '';
    //Min Width
    const tokenDecrpt = bytes.toString(cryptoJs.enc.Utf8);
    // Variable where we will store the value of the sessionStorage
    const [loading, setLoading] = useState(false);
    const [role, setRole] = useState(null);

    useEffect(() => {
        dispatch(IsDevelopment(false));
    }, []);

    useEffect(() => {
        // Fetch language for user after login
        if(user?.id){
            dispatch(GetUserPreferencesByUserId(user.id)).then(({payload:{data:{data}}})=>{
                syncI18nLanguageFromBackend(data?.language);
            })
        }
    }, [user?.id]);

    // min width
    // Layout effect so it runs before the effects of the new page, otherwise it hides the loader of its first request //
    useLayoutEffect(() => {
        if (document.getElementById('overlay')) {
            document.getElementById('overlay').style.display = 'none';
        }
        if (document.getElementById('second-overlay')) {
            document.getElementById('second-overlay').style.display = 'none';
        }
    }, [navigate]);

    useEffect(() => {
        if (!token) return;

        const tokeninfo = jwt(token);
        const expireDate = tokeninfo?.exp * 1000;
        const checkExpiration = () => {
            if (Date.now() >= expireDate) {
                toast.warning(t('your_session_has_expired'));
                setTimeout(() => {
                    dispatch(logOut());
                    navigate(routes.home);
                }, 2000);

                return true;
            }

            return false;
        };

        if (checkExpiration()) return;

        const interval = setInterval(checkExpiration, 60000);

        return () => clearInterval(interval);
    }, [token, navigate, dispatch, t]);

   NotificationsWebSocketApp({ tokenDecrpt, user, dispatch, t});

    // this useEffect to redirect auth user to page
    useEffect(() => {
        if (token && location.pathname === '/' && user) {
            // Residents land directly on their apartments module
            navigate(user?.userType?.id === USER_TYPE_MODEL.RESIDENT ? routes.myApartment.list : routes.login);
        }
    }, [token]);

    // it will check the token and call api to fetch
    // the premmission at entry point

    useEffect(() => {
        if (token) {
            const tokeninfo = jwt(token);
            const data = {
                roleId: tokeninfo?.role_id
            };

            if(data.roleId !== USER_TYPE_NAME_MODEL.NONE)
                dispatch(RoleCheck(data));

            if (user?.userType?.name === USER_TYPE_NAME_MODEL.EMPLOYEE) {
                dispatch(GetUserByIdAtEntry()).then(({ payload: { data: { data } } }) => {
                    setRole(data?.roleName);
                });
            }
        }
    }, [token]);

    // Function to handle the message received from another window
    const handleStorageChange = event => {
        // Check if the received message is of the expected type
        if (event.data && event.data.type === 'sessionStorageChangeLoader') {
            // Update the variable with the new value
            const newValueLoading = event.data.newValueLoading !== null ? event.data.newValueLoading : false;
            setLoading(newValueLoading);
        }
    };

    useEffect(() => {
        window.addEventListener('message', handleStorageChange);

        return () => {
            window.removeEventListener('message', handleStorageChange);
        };
    }, []);

    useEffect(() => {
        if (loading) {
            if (document.getElementById('overlay')) {
                document.getElementById('overlay').style.display = 'none';
            }
        } else {
            if (document.getElementById('overlay')) {
                document.getElementById('overlay').style.display = 'none';
            }
        }
    }, [loading]);

    return (
        <>
            <div>
                <div>
                    <SnackbarProvider anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                        <FullPageLoader />
                        {loading && <SecondPageLoader />}
                        <FingerPrintSpinner />
                        <NavigationHandler />
                        <DndProvider backend={HTML5Backend}>
                            <MainRoutes />

                            <ToastContainer
                                position='top-right'
                                autoClose={4000}
                                hideProgressBar={false}
                                newestOnTop
                                closeOnClick
                                transition={Slide}
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                            />
                            { (role
                                || user?.userType?.name === USER_TYPE_NAME_MODEL.CONTRACTOR_IN_CHARGE
                                || user?.userType?.name === USER_TYPE_NAME_MODEL.SUPPLIER_IN_CHARGE)
                            && <NotificationsButton />}
                        </DndProvider>
                    </SnackbarProvider>
                </div>
            </div>
        </>
    );
};

export default App;
